/**
 *  Highlighter -
 *  sucht innerhalb des Containers nach Texten und packt diese in einen <span>
 *  dafür wird die Klasse auf den <span> angewendet
 *
 *  Constructor Parameter: Container in dem gesucht werden soll
 *
 *  Für das Highlighting muss ein span mit der Klasse im CSS definiert sein, ausser
 *  es wurde ein neues Element und neue Klasse definiert
 *
 */
class Highlighter {

    _container = null;
    _searchTerm = null;
    _highlightingClass = 'search-highlighting';
    _highlightingElement = 'span'
    _searchedElement = null;
    _minStringLengthForSearching = 1;

    /**
     * Übergibt im Constructor den Container in dem gesucht wird
     * @param container
     */
    constructor(container = null) {
        this._container = document.querySelector(container);
    }

    /**
     * Definiert das HTML Element für das highlighting
     * @param element
     */
    setHighlightingElement = (element)=>{
        this._highlightingElement = element;
    }

    /**
     * Definiert die CSS Klasse die angewendet wird
     * @param hightlightingClass
     */
    setHighlightingClass = (hightlightingClass)=>{
        this._highlightingClass = hightlightingClass;
    }

    /**
     * Definiert den Text der gesucht wird
     * @param searchTerm
     */
    setSearchTerm = (searchTerm)=>{
        this._searchTerm = searchTerm;
    }

    /**
     * Definiert das Element nachdem im Container für die Text Prüfung gesucht wird
     * @param element
     */
    setSearchedElement = (element)=>{
        this._searchedElement = element;
    }

    /**
     * Definiert ab welcher Zeichenlänge frühestens gesucht wird
     * @param length
     */
    setMinStringLengthForSearching = (length)=>{
        this._minStringLengthForSearching = length;
    }


    /**
     * Führt das Highlighting durch
     */
    process = ()=> {

        if(
            this._searchTerm !== null
            && this._searchTerm !== ''
            && this._searchTerm.length > this._minStringLengthForSearching
        ){
            let elements = this._container.querySelectorAll(this._searchedElement);
            let htmlElement = '<'+this._highlightingElement+' class="'+this._highlightingClass+'">$1</'+this._highlightingElement+'>';
            let searchTerm = this._searchTerm;

            elements.forEach(function(value, key, parent){
                searchTerm = searchTerm.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
                let pattern = new RegExp("("+searchTerm+")", "gi");
                let sourceString = value.textContent;
                sourceString = sourceString.replace(pattern, htmlElement);
                value.innerHTML = sourceString;
            })
        }else{
            let highlightingElementClass = this._highlightingElement+'.'+this._highlightingClass;
            let elements = this._container.querySelectorAll(highlightingElementClass);

            elements.forEach(function(value, key, parent){
                let parentElement = value.parentElement;
                parentElement.innerHTML = parentElement.textContent;
            });
        }

    }


}